import styled, { css } from 'styled-components';

export const CheckboxSC = styled.span<{ disabled?: boolean; readOnly?: boolean; error?: boolean }>`
  display: inline-flex;
  position: relative;
  transition: all 0.2s;

  &.ui-checkbox-children {
    margin: 12px 0;
  }

  &,
  label {
    display: flex;
    ${({ disabled, readOnly }) =>
      disabled || readOnly
        ? css`
            cursor: not-allowed;
            opacity: 0.5;
          `
        : css`
            cursor: pointer;
            opacity: 1;
          `};
  }

  label {
    position: relative;
    margin-bottom: 0;

    color: ${({ theme }) => theme.color.tint.action};

    &:before {
      transition: all 0.2s;
      z-index: 0;
      content: '';
      position: absolute;
      inset: -6px;
      border-radius: 32px;
    }

    &:hover {
      &:before {
        background-color: ${({ theme }) => theme.color.state.ripple};
      }
    }
  }

  input {
    position: absolute;
    opacity: 0;
    transition: all 0.2s;

    &:checked + .checkbox {
      .ui-checkbox-mark {
        opacity: 1;
      }
    }
  }

  .checkbox {
    width: 20px;
    height: 20px;
    z-index: 1;

    display: flex;
    align-items: center;
    justify-content: center;

    transition: all 0.2s;

    .ui-checkbox-mark {
      transition: all 0.3s;
      opacity: 0;
    }
  }

  ${({ theme, error }) => {
    const backgroundColor = error ? theme.color.surface.error : theme.color.surface.variant;
    const borderColor = error ? theme.color.border.error : theme.color.tint.tertiary;
    const selectedColor = error ? theme.color.tint.error : theme.color.solid.selection;

    return css`
      .checkbox {
        border-radius: ${({ theme }) => theme.radius.extraSmall}px;
        border: 2px solid ${borderColor};
        background-color: ${backgroundColor};
      }

      input:checked + .checkbox {
        border-color: ${selectedColor};
        background-color: ${selectedColor};
      }

      &:hover {
        .checkbox {
          border-color: ${theme.createOverlayColor(borderColor, 'hover')};
          background-color: ${theme.createOverlayColor(backgroundColor, 'hover')};
        }

        input:checked + .checkbox {
          border-color: ${theme.createOverlayColor(selectedColor, 'hover')};
          background-color: ${theme.createOverlayColor(selectedColor, 'hover')};
        }
      }
    `;
  }};

  .checkbox-text-wrapper {
    flex: 1;
    margin-left: 16px;
    color: ${({ theme }) => theme.color.tint.action};
    ${({ theme }) => theme.mappedTypography.overline.default};
  }
`;
